<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting" id="also-by">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">ALSO BY AILEEN ERIN</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">The Complete Alpha Girls Series</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/becoming-alpha" target="_blank"><i>Becoming Alpha</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/avoiding-alpha" target="_blank"><i>Avoiding Alpha</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/alpha-divided" target="_blank"><i>Alpha Divided</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/bruja" target="_blank"><i>Bruja</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/alpha-unleashed" target="_blank"><i>Alpha Unleashed</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/shattered-pack" target="_blank"><i>Shattered Pack</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/being-alpha" target="_blank"><i>Being Alpha</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/lunar-court" target="_blank"><i>Lunar Court</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/alpha-erased" target="_blank"><i>Alpha Erased</i></a></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">The Shadow Ravens Series</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><span class="content-external-link"><i>Cipher</i></span></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">The Aunare Chronicles</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/off-planet" target="_blank"><i>Off Planet</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/off-balance" target="_blank"><i>Off Balance</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/in-command" target="_blank"><i>In Command</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/on-mission" target="_blank"><i>On Mission</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://www.aileenerin.com/on-destiny" target="_blank"><i>On Destiny</i></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-aileen-erin.vue?ae7038a4